import { DASHBOARD_ITEM, MENU } from "./adminConfig";
import { useAuth } from "../../context/AuthContext";
import { API } from '../../api';

export default function Sidebar({ sidebarOpen, toggleSidebar, selectedItem, openSections, toggleSection, handleSelect, }) {
	const { user, loading } = useAuth();
	return (
		<aside className={`sidebar-panel ${sidebarOpen ? "open" : "collapsed"}`}>
			<div className="sidebar-top">
				<div className="sidebar-brand">Panel admin</div>
				<button type="button" className={`sidebar-toggle ${sidebarOpen ? "open" : ""}`} onClick={toggleSidebar} aria-label="Ouvrir/fermer le menu">
					<span className="burger">
						<span className="burger-line" />
						<span className="burger-line" />
						<span className="burger-line" />
					</span>
				</button>
			</div>

			<img
				src={`${API.API_LINK}/file/pictures/logo/source/logo_l_atelier_floral180x260.png`}
				alt="Logo L'Atelier Floral"
				className="sidebar-logo"
				onClick={() => handleSelect(DASHBOARD_ITEM)}
			/>

			<button type="button" className={`dashboard-entry ${selectedItem.id === "dashboard" ? "active" : ""}`} onClick={() => handleSelect(DASHBOARD_ITEM)}>
				<span className="item-bullet" /> {sidebarOpen && <span>Vue d'ensemble</span>}
			</button>

			<div className="sidebar-sections">
				{MENU.map((section) => {
					const isOpen = openSections[section.id];
					const isVisible = section.items.some(item => item.permission === "" || user.frontend_permissions[item.permission]?.access?.allowed === true );
					if (!isVisible) return null;
					return (
						<div key={section.id} className="sidebar-section">
							<button type="button" className="section-header" onClick={() => toggleSection(section.id)} aria-expanded={isOpen}>
								<div className="section-label">
									<span className="section-dot" />{sidebarOpen && <span>{section.label}</span>}
								</div>
								<span className={`chevron ${isOpen ? "open" : ""}`} />
							</button>

							<div className={`section-items ${isOpen ? "open" : ""}`}>
								{section.items.map((item) => (
									(item.permission === "" || user.frontend_permissions[item.permission]?.access?.allowed === true ) && (
										<button key={item.id} type="button" className={`section-item ${selectedItem.id === item.id ? "active" : ""}`} 
										onClick={() => { if (user.frontend_permissions[item.permission]?.access?.allowed === false) return; handleSelect(item); }}>
											<span className="item-bullet" />{sidebarOpen && <span>{item.label}</span>}
										</button>
									)
								))}
							</div>
						</div>
					);
				})}
			</div>
		</aside>
	);
}